module.exports = __webpack_public_path__ + "static/media/start-time.3f5ee6e7.svg";